import { Action } from "@reduxjs/toolkit";
import { OwnerState } from "./types";
import { isType } from "typescript-fsa";
import { ownerActions } from "./actions";

const initialState: OwnerState = {
    total_items: 0,
    total_pages: 0,
    current_page: 1,
    page_size: 10,
    next_page: null,
    previous_page: null,
    owners: []
}

export function OwnerReducer(state = initialState, action: Action): OwnerState {
    if (isType(action, ownerActions.fetchOwners.done)) {
        const data = action.payload.result
        return {
            ...state,
            total_items: data.total_items,
            total_pages: data.total_pages,
            current_page: data.current_page,
            page_size: data.page_size,
            next_page: data.next_page,
            previous_page: data.previous_page,
            owners: data.data.map((owner) => ({
                id: owner.id,
                name: owner.name,
                email: owner.email,
                phone_number: owner.phone_number,
                other_phone_number: owner.other_phone_number ?? "",
                created_at: owner.created_at,
            }))
        }
    }

    if (isType(action, ownerActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}